export enum GastroShopOrderStatus {
    OPEN = "open",
    COMPLETED = "completed",
}
